import illustrationUrls from './illustrationUrls'; // @ts-expect-error bender-url not typed

import recaptchaVerification from 'bender-url!../../images/recaptcha-verification.svg'; // @ts-expect-error bender-url not typed

import connectLogo from 'bender-url!../../images/connect.com-full-logo-color.png'; // @ts-expect-error bender-url not typed

import connectMobileLogo from 'bender-url!../../images/connect.com-infinity-icon-color.png'; // @ts-expect-error bender-url not typed

import personWithBox1x from 'bender-url!../../images/person-with-box/person-with-box@1x.svg'; // @ts-expect-error bender-url not typed

import personWithBox2x from 'bender-url!../../images/person-with-box/person-with-box@2x.svg'; // @ts-expect-error bender-url not typed

import personWithBox3x from 'bender-url!../../images/person-with-box/person-with-box@3x.svg'; // @ts-expect-error bender-url not typed

import crmCentralPlace1x from 'bender-url!../../images/crm-central-place/crm-central-place@1x.svg'; // @ts-expect-error bender-url not typed

import crmCentralPlace2x from 'bender-url!../../images/crm-central-place/crm-central-place@2x.svg'; // @ts-expect-error bender-url not typed

import crmCentralPlace3x from 'bender-url!../../images/crm-central-place/crm-central-place@3x.svg'; // @ts-expect-error bender-url not typed

import blondeShelley1x from 'bender-url!../../images/blonde-shelley/blonde-shelley@1x.png'; // @ts-expect-error bender-url not typed

import blondeShelley2x from 'bender-url!../../images/blonde-shelley/blonde-shelley@2x.png'; // @ts-expect-error bender-url not typed

import blondeShelley3x from 'bender-url!../../images/blonde-shelley/blonde-shelley@3x.png'; // @ts-expect-error bender-url not typed

import wordpressAuthorizationConnect from 'bender-url!../../images/wordpress-authorization-connect.svg'; // @ts-expect-error bender-url not typed

import emailAnimation from 'bender-url!../../images/animated-images/email_open.webm'; // @ts-expect-error bender-url not typed

import academyLogo from 'bender-url!../../images/academy/hubspot-academy-logo.svg'; // @ts-expect-error bender-url not typed

import microsoftLogo from 'bender-url!../../images/logos/microsoft.png'; // @ts-expect-error bend-url not typed

import salesExtensionInstall from 'bender-url!../../images/email-tracking-flow/sales-extension-install.png'; // @ts-expect-error bend-url not typed

import checkSign from 'bender-url!../../images/email-tracking-flow/check-sign.png'; // @ts-expect-error bend-url not typed

import salesExtensionReview from 'bender-url!../../images/email-tracking-flow/sales-extension-review.png'; // @ts-expect-error bender-url not typed

import chatSpotLogo from 'bender-url!../../images/chatspot.png'; // @ts-expect-error bender-url not typed

import chatSpotMobileLogo from 'bender-url!../../images/chatspot-mobile.png'; // @ts-expect-error bender-url not typed

import welcomeImage from 'bender-url!../../images/welcome.svg'; // @ts-expect-error bender-url not typed

import appleLogoWhite from 'bender-url!../../images/logos/apple_white.png'; // @ts-expect-error bender-url not typed

import linkedinLogoWhite from 'bender-url!../../images/logos/linkedin_white.png'; // @ts-expect-error bender-url not typed

import paypalLogo from 'bender-url!../../images/logos/paypal.png'; // @ts-expect-error bender-url not typed

import wordpressLogo from 'bender-url!../../images/logos/wordpress.png'; // @ts-expect-error bender-url not typed

import arrowIcon from 'bender-url!../../images/arrow-icon.png'; // @ts-expect-error bender-url not typed

import stars from 'bender-url!../../images/gswh-star.png'; // @ts-expect-error bender-url not typed

import generateBlogPost from 'bender-url!../../images/generate-blog-post.png';
export default Object.assign({
  personWithBox1x,
  personWithBox2x,
  personWithBox3x,
  crmCentralPlace1x,
  crmCentralPlace2x,
  crmCentralPlace3x,
  blondeShelley1x,
  blondeShelley2x,
  blondeShelley3x,
  recaptchaVerification,
  wordpressAuthorizationConnect,
  emailAnimation,
  connectLogo,
  connectMobileLogo,
  academyLogo,
  microsoftLogo
}, illustrationUrls, {
  salesExtensionInstall,
  salesExtensionReview,
  checkSign,
  chatSpotLogo,
  chatSpotMobileLogo,
  welcomeImage,
  appleLogoWhite,
  linkedinLogoWhite,
  paypalLogo,
  wordpressLogo,
  arrowIcon,
  stars,
  generateBlogPost
});